var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRedo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0v24h24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M17 19v-2H9.9q-1.575 0-2.737-1T6 13.5c0-1.5.387-1.833 1.163-2.5q1.162-1 2.737-1h6.3l-2.6 2.6L15 14l5-5-5-5-1.4 1.4L16.2 8H9.9Q7.475 8 5.738 9.575T4 13.5t1.738 3.925Q7.475 19 9.9 19z"
}))));
export default SvgIconRedo;